module.exports = __webpack_public_path__ + "34736292/img/comments-icon.fdec7fdb.svg";